import {
  deriveOptionCodesFromProduct,
  getIsAllOutOfStock,
  getIsOutOfStock
} from "@/util/productFullDetailUtil"
import {
  useMemo, useState 
} from "react"
import type {
  OptionsSelectionsMap 
} from "../lib/get-optionSelections"
import {
  ProductRoot 
} from "../types/product"

export const useIsOutofStock = ({
  product,
  optionSelections


}: {
    product: ProductRoot,
    optionSelections: OptionsSelectionsMap
}) => {

  const derivedOptionCodes = useMemo(
    () => deriveOptionCodesFromProduct(product),
    [product]
  )
  const [optionCodes] = useState(derivedOptionCodes)

  // 所有的全部缺货
  const isEverythingOutOfStock = useMemo(
    () => getIsAllOutOfStock(product),
    [product]
  )

  const isOutOfStock = useMemo(
    () => getIsOutOfStock(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections]
  )


  return {
    isEverythingOutOfStock,
    isOutOfStock
  }
}
